import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("g", {
        clipPath: "url(#zi2i2yov3__clip0_10_16453)",
        children: _jsx("path", {
          d: "M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V9H19V19ZM19 7H5V5H19V7ZM7 11H12V16H7V11Z",
          fill: "#152361"
        })
      }), _jsx("defs", {
        children: _jsx("clipPath", {
          id: "zi2i2yov3__clip0_10_16453",
          children: _jsx("rect", {
            width: "24",
            height: "24",
            fill: "white"
          })
        })
      })]
    }))
  });
};
export default Component;
